(function () {
  'use strict';

  if (window.gigiClickTrackingReady) return;
  window.gigiClickTrackingReady = true;

  var ATTRIBUTION_TTL_MS = 30 * 24 * 60 * 60 * 1000;
  var ATTRIBUTION_STORAGE_KEY = 'gigi:event-attribution:v1';
  var MAX_TOUCH_LENGTH = 2048;
  var MAX_UTM_LENGTH = 160;
  var SOURCE_CODE_PATTERN = /^[a-f0-9]{32}$/;
  var TOUCH_ISSUER = 'gigibase-event-attribution';
  var TOUCH_AUDIENCE = 'gigi-shopify-attribution';
  var TOUCH_SCOPE = 'event_attribution_touch';
  var TOUCH_SUBJECT_PREFIX = 'gigi-event-attribution:';
  var ATTRIBUTION_QUERY_KEYS = {
    source: 'gigi_event_source',
    touch: 'gigi_event_touch',
    utmSource: 'utm_source',
    utmMedium: 'utm_medium',
    utmCampaign: 'utm_campaign',
    utmTerm: 'utm_term',
    utmContent: 'utm_content',
  };
  var PRIVATE_ATTRIBUTION_KEYS = {
    source: '__gigi_event_source',
    touch: '__gigi_event_touch',
    utmSource: '__utm_source',
    utmMedium: '__utm_medium',
    utmCampaign: '__utm_campaign',
    utmTerm: '__utm_term',
    utmContent: '__utm_content',
  };
  var PRIVATE_ATTRIBUTION_KEY_LIST = [
    PRIVATE_ATTRIBUTION_KEYS.source,
    PRIVATE_ATTRIBUTION_KEYS.touch,
    PRIVATE_ATTRIBUTION_KEYS.utmSource,
    PRIVATE_ATTRIBUTION_KEYS.utmMedium,
    PRIVATE_ATTRIBUTION_KEYS.utmCampaign,
    PRIVATE_ATTRIBUTION_KEYS.utmTerm,
    PRIVATE_ATTRIBUTION_KEYS.utmContent,
  ];
  var attributionWritePromise = null;

  function textLabel(element) {
    if (!element) return '';
    return (element.getAttribute('aria-label') || element.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function targetFor(element) {
    if (!element) return '';
    if (element.dataset && element.dataset.gigiTrackTarget) return element.dataset.gigiTrackTarget;
    if (element.href) return element.href;
    var form = element.closest && element.closest('form');
    return form ? form.getAttribute('action') || '' : '';
  }

  function basePayload(element) {
    return {
      gigi_label: element && element.dataset && element.dataset.gigiTrackLabel ? element.dataset.gigiTrackLabel : textLabel(element),
      gigi_path: window.location.pathname,
      gigi_target: targetFor(element),
    };
  }

  function pushTrackingEvent(eventName, properties) {
    var eventProperties = properties || {};
    var dataLayerPayload = Object.assign({ event: eventName }, eventProperties);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(dataLayerPayload);

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, eventProperties);
    }

    if (
      window.Shopify &&
      window.Shopify.analytics &&
      typeof window.Shopify.analytics.publish === 'function'
    ) {
      window.Shopify.analytics.publish(eventName, eventProperties);
    }

    if (
      window.ShopifyAnalytics &&
      window.ShopifyAnalytics.lib &&
      typeof window.ShopifyAnalytics.lib.track === 'function'
    ) {
      window.ShopifyAnalytics.lib.track(eventName, eventProperties);
    }

    window.dispatchEvent(new CustomEvent('gigi:track', { detail: dataLayerPayload }));
  }

  function decodeBase64Url(value) {
    var normalized = value.replace(/-/g, '+').replace(/_/g, '/');
    while (normalized.length % 4) normalized += '=';

    var binary = atob(normalized);
    if (typeof TextDecoder !== 'function') return binary;

    var bytes = new Uint8Array(binary.length);
    for (var index = 0; index < binary.length; index += 1) {
      bytes[index] = binary.charCodeAt(index);
    }
    return new TextDecoder().decode(bytes);
  }

  function decodeTouchPayload(touch) {
    if (typeof touch !== 'string' || !touch || touch.length > MAX_TOUCH_LENGTH) return null;

    var parts = touch.split('.');
    if (parts.length !== 3 || !parts[0] || !parts[1] || !parts[2]) return null;

    try {
      var payload = JSON.parse(decodeBase64Url(parts[1]));
      return payload && typeof payload === 'object' && !Array.isArray(payload) ? payload : null;
    } catch (error) {
      return null;
    }
  }

  function queryValue(params, key) {
    var value = params.get(key);
    if (value === null) return null;

    value = value.trim();
    return value || null;
  }

  function validUtmValue(value) {
    return value === null || (typeof value === 'string' && value.length <= MAX_UTM_LENGTH);
  }

  function touchExpiry(source, touch, now) {
    if (!SOURCE_CODE_PATTERN.test(source) || touch.length > MAX_TOUCH_LENGTH) return null;

    var payload = decodeTouchPayload(touch);
    if (
      !payload ||
      payload.code !== source ||
      payload.iss !== TOUCH_ISSUER ||
      payload.aud !== TOUCH_AUDIENCE ||
      payload.scope !== TOUCH_SCOPE ||
      payload.sub !== TOUCH_SUBJECT_PREFIX + source ||
      typeof payload.iat !== 'number' ||
      !Number.isFinite(payload.iat) ||
      typeof payload.exp !== 'number' ||
      !Number.isFinite(payload.exp)
    ) {
      return null;
    }

    var lifetime = payload.exp - payload.iat;
    if (lifetime <= 0 || lifetime > ATTRIBUTION_TTL_MS / 1000 + 60) return null;

    var jwtIssuedAt = payload.iat * 1000;
    var jwtExpiresAt = payload.exp * 1000;
    if (!Number.isFinite(jwtIssuedAt) || !Number.isFinite(jwtExpiresAt)) return null;

    return {
      issuedAt: jwtIssuedAt,
      expiresAt: Math.min(jwtExpiresAt, now + ATTRIBUTION_TTL_MS),
    };
  }

  function readRedirectAttribution() {
    if (!window.location || !window.location.search) return null;

    var params = new URLSearchParams(window.location.search);
    var source = queryValue(params, ATTRIBUTION_QUERY_KEYS.source);
    var touch = queryValue(params, ATTRIBUTION_QUERY_KEYS.touch);
    if (!source || !touch) return null;

    var now = Date.now();
    var touchDetails = touchExpiry(source, touch, now);
    if (!touchDetails || touchDetails.expiresAt <= now) return null;

    var attribution = {
      source: source,
      touch: touch,
      issuedAt: touchDetails.issuedAt,
      expiresAt: touchDetails.expiresAt,
      utmSource: queryValue(params, ATTRIBUTION_QUERY_KEYS.utmSource),
      utmMedium: queryValue(params, ATTRIBUTION_QUERY_KEYS.utmMedium),
      utmCampaign: queryValue(params, ATTRIBUTION_QUERY_KEYS.utmCampaign),
      utmTerm: queryValue(params, ATTRIBUTION_QUERY_KEYS.utmTerm),
      utmContent: queryValue(params, ATTRIBUTION_QUERY_KEYS.utmContent),
    };

    if (![attribution.utmSource, attribution.utmMedium, attribution.utmCampaign, attribution.utmTerm, attribution.utmContent].every(validUtmValue)) {
      return null;
    }

    return attribution;
  }

  function desiredPrivateAttributes(attribution) {
    return {
      [PRIVATE_ATTRIBUTION_KEYS.source]: attribution.source,
      [PRIVATE_ATTRIBUTION_KEYS.touch]: attribution.touch,
      [PRIVATE_ATTRIBUTION_KEYS.utmSource]: attribution.utmSource || '',
      [PRIVATE_ATTRIBUTION_KEYS.utmMedium]: attribution.utmMedium || '',
      [PRIVATE_ATTRIBUTION_KEYS.utmCampaign]: attribution.utmCampaign || '',
      [PRIVATE_ATTRIBUTION_KEYS.utmTerm]: attribution.utmTerm || '',
      [PRIVATE_ATTRIBUTION_KEYS.utmContent]: attribution.utmContent || '',
    };
  }

  function emptyPrivateAttributes() {
    var desired = {};
    for (var index = 0; index < PRIVATE_ATTRIBUTION_KEY_LIST.length; index += 1) {
      desired[PRIVATE_ATTRIBUTION_KEY_LIST[index]] = '';
    }
    return desired;
  }

  function attributesFingerprint(attributes) {
    return JSON.stringify(
      PRIVATE_ATTRIBUTION_KEY_LIST.map(function (key) {
        return [key, attributes[key]];
      })
    );
  }

  function clearState() {
    var desired = emptyPrivateAttributes();
    return {
      mode: 'clear',
      desiredFingerprint: attributesFingerprint(desired),
      lastSyncedCartToken: null,
      syncStatus: 'pending',
    };
  }

  function optionalStoredValue(value) {
    if (value === undefined || value === null || value === '') return null;
    return typeof value === 'string' && validUtmValue(value) ? value : undefined;
  }

  function normalizedStoredState(stored) {
    if (!stored || typeof stored !== 'object') return null;

    if (stored.mode === 'clear') {
      var clear = clearState();
      if (typeof stored.lastSyncedCartToken === 'string' && stored.lastSyncedCartToken) {
        clear.lastSyncedCartToken = stored.lastSyncedCartToken;
      }
      if (
        stored.syncStatus === 'synced' &&
        clear.lastSyncedCartToken &&
        stored.desiredFingerprint === clear.desiredFingerprint
      ) {
        clear.syncStatus = 'synced';
      }
      return clear;
    }

    if (
      typeof stored.source !== 'string' ||
      typeof stored.touch !== 'string' ||
      typeof stored.expiresAt !== 'number' ||
      !Number.isFinite(stored.expiresAt)
    ) {
      return null;
    }

    var touchDetails = touchExpiry(stored.source, stored.touch, Date.now());
    if (!touchDetails) return null;

    var attribution = {
      source: stored.source,
      touch: stored.touch,
      issuedAt: touchDetails.issuedAt,
      expiresAt: Math.min(stored.expiresAt, touchDetails.expiresAt),
      utmSource: optionalStoredValue(stored.utmSource),
      utmMedium: optionalStoredValue(stored.utmMedium),
      utmCampaign: optionalStoredValue(stored.utmCampaign),
      utmTerm: optionalStoredValue(stored.utmTerm),
      utmContent: optionalStoredValue(stored.utmContent),
    };
    if (
      attribution.utmSource === undefined ||
      attribution.utmMedium === undefined ||
      attribution.utmCampaign === undefined ||
      attribution.utmTerm === undefined ||
      attribution.utmContent === undefined
    ) {
      return null;
    }

    var desired = desiredPrivateAttributes(attribution);
    var expectedFingerprint = attributesFingerprint(desired);
    var lastSyncedCartToken =
      typeof stored.lastSyncedCartToken === 'string' && stored.lastSyncedCartToken
        ? stored.lastSyncedCartToken
        : null;
    var state = Object.assign({}, attribution, {
      mode: 'active',
      desiredFingerprint: expectedFingerprint,
      lastSyncedCartToken: lastSyncedCartToken,
      syncStatus:
        stored.syncStatus === 'synced' &&
        lastSyncedCartToken &&
        stored.desiredFingerprint === expectedFingerprint
          ? 'synced'
          : 'pending',
    });
    return state;
  }

  function storedState() {
    var raw;
    try {
      raw = window.localStorage.getItem(ATTRIBUTION_STORAGE_KEY);
    } catch (error) {
      return { state: null, available: false };
    }

    if (!raw) return { state: null, available: true };

    try {
      var state = normalizedStoredState(JSON.parse(raw));
      return { state: state || clearState(), available: true };
    } catch (error) {
      return { state: clearState(), available: true };
    }
  }

  function saveStoredAttribution(attribution) {
    try {
      window.localStorage.setItem(ATTRIBUTION_STORAGE_KEY, JSON.stringify(attribution));
      return true;
    } catch (error) {
      return false;
    }
  }

  function clearStoredAttribution() {
    try {
      window.localStorage.removeItem(ATTRIBUTION_STORAGE_KEY);
      return true;
    } catch (error) {
      return false;
    }
  }

  function reconcileRedirectAttribution() {
    var landingAttribution = readRedirectAttribution();
    var storage = storedState();
    var storedAttribution = storage.state;
    var landingWins = Boolean(
      landingAttribution &&
        (!storedAttribution ||
          storedAttribution.mode !== 'active' ||
          storedAttribution.expiresAt <= Date.now() ||
          landingAttribution.issuedAt >= storedAttribution.issuedAt)
    );
    var state = landingWins
      ? Object.assign({}, landingAttribution, {
          mode: 'active',
          desiredFingerprint: attributesFingerprint(desiredPrivateAttributes(landingAttribution)),
          lastSyncedCartToken: null,
          syncStatus: 'pending',
        })
      : storage.state;
    if (!state) return;

    if (landingWins) {
      storage.available = saveStoredAttribution(state);
    }

    if (state.mode === 'active' && state.expiresAt <= Date.now()) {
      state = clearState();
      if (storage.available) saveStoredAttribution(state);
    }
    var desired = state.mode === 'clear' ? emptyPrivateAttributes() : desiredPrivateAttributes(state);

    if (attributionWritePromise) return;

    attributionWritePromise = fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    })
      .then(function (response) {
        if (!response || response.ok === false) throw new Error('Cart read failed.');
        return response.json();
      })
      .then(function (cart) {
        var cartToken = cart && typeof cart.token === 'string' ? cart.token : '';
        if (!cartToken) throw new Error('Cart token missing.');

        if (state.mode === 'active' && state.expiresAt <= Date.now()) {
          state = clearState();
          desired = emptyPrivateAttributes();
          if (storage.available) saveStoredAttribution(state);
        }

        if (
          state.syncStatus === 'synced' &&
          state.lastSyncedCartToken === cartToken &&
          state.desiredFingerprint === attributesFingerprint(desired)
        ) {
          return { cartToken: cartToken, syncedState: state };
        }

        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ attributes: desired }),
        }).then(function (response) {
          if (!response || response.ok === false) throw new Error('Cart update failed.');
          return { cartToken: cartToken, syncedState: state };
        });
      })
      .then(function (result) {
        if (!result) return;

        var syncedState = Object.assign({}, result.syncedState, {
          lastSyncedCartToken: result.cartToken,
          syncStatus: 'synced',
        });
        if (syncedState.mode === 'clear') {
          if (!clearStoredAttribution()) saveStoredAttribution(syncedState);
        } else {
          saveStoredAttribution(syncedState);
        }
      })
      .catch(function () {
        // Keep the local record so a later load can retry after a fetch failure.
      })
      .then(function () {
        attributionWritePromise = null;
      });
  }

  function pathFromHref(href) {
    try {
      return new URL(href, window.location.href);
    } catch (error) {
      return null;
    }
  }

  function inferredLinkEvent(link) {
    var url = pathFromHref(link.getAttribute('href'));
    if (!url) return '';

    if (url.hash === '#shop-gigi') return 'gigi_shop_gigi_click';
    if (url.pathname === '/stock-gigi' || url.pathname === '/pages/stock-gigi') return 'gigi_stock_gigi_click';
    if (url.pathname === '/get-in-touch' || url.pathname === '/pages/contact') return 'gigi_contact_cta_click';

    return '';
  }

  document.addEventListener('click', function (event) {
    var clickedElement = event.target && event.target.nodeType === 1 ? event.target : event.target.parentElement;
    if (!clickedElement) return;

    var trackedElement = clickedElement.closest('[data-gigi-track]');
    if (trackedElement) {
      pushTrackingEvent(trackedElement.dataset.gigiTrack, basePayload(trackedElement));
      return;
    }

    var link = clickedElement.closest('a[href]');
    var eventName = link ? inferredLinkEvent(link) : '';
    if (!eventName) return;

    pushTrackingEvent(eventName, basePayload(link));
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form')) return;

    var eventName = form.dataset.gigiTrackSubmit || '';
    if (!eventName) {
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') !== -1) eventName = 'gigi_add_to_cart_submit';
    }

    if (!eventName) return;

    pushTrackingEvent(eventName, basePayload(form));
  });

  reconcileRedirectAttribution();
})();
